import React from "react";
import { LineChart } from "@mui/x-charts";

interface MuiAreaChartProps {
  xLabels: string[];
  yData: number[];
  label: string;
  height?: number;
  color?: string;
}

const MuiAreaChart: React.FC<MuiAreaChartProps> = ({
  xLabels,
  yData,
  label,
  height = 300,
  color = "#3e59e3"
}) => {
  return (
    <LineChart
      height={height}
      xAxis={[{ scaleType: "point", data: xLabels }]}
      series={[
        {
          data: yData,
          label,
          area: true,
          color,
        },
      ]}
    />
  );
};

export default MuiAreaChart;
